import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { ItemVerbaFuncionarioDropDown } from "../../../domain/models/item_verba_funcionario_dropdown";

/**
 * useFolhaPagamentoItensVerbaFilter
 */

type State = {
  itensVerbaFuncionario: ItemVerbaFuncionarioDropDown[] | undefined;
};

type Actions = {
  setItensVerbaFuncionario: SetFunction<ItemVerbaFuncionarioDropDown[] | undefined>,
};

export const useFolhaPagamentoItensVerbaFilter = create<State & Actions>((set) => ({
  itensVerbaFuncionario: undefined,
  setItensVerbaFuncionario: vfn => SetFunctionImpl(set, 'itensVerbaFuncionario', vfn),
}));